import queryUtils from 'app/shared/utils/queryUtils';

type RecentSearchSyncQuery = Record<string, string | number | boolean | undefined>;

type RecentSearchSyncInput = {
  pathname?: string;
  query?: RecentSearchSyncQuery;
  recentSearch?: {
    url?: string;
  };
};

export const shouldSyncRecentSearchOnSrpMount = ({ pathname, query, recentSearch }: RecentSearchSyncInput): boolean => {
  const recentSearchUrl = recentSearch?.url;

  if (!pathname || !recentSearchUrl) {
    return false;
  }

  // Both sides must use queryUtils.stringify for consistent key ordering.
  // The SRP URL is built from the browser's parsed query; the recentSearch URL
  // is built from adapt_reduxToQuery (Redux filter state) + queryUtils.stringify.
  // If either side produces extra or missing params, this comparison will
  // report "stale" and trigger a sync — a safe false-positive over a missed sync.
  const currentSrpUrl = pathname + queryUtils.stringify(query || {});

  return recentSearchUrl !== currentSrpUrl;
};
